export default __webpack_public_path__ + "static/media/ISMO CLASS-7_SYLLABUS_2025-26.221db95e.pdf";